import React, { useEffect } from "react";
import { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./HeaderOffcanvas.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGift } from "@fortawesome/free-solid-svg-icons";
import { Occasion, priceRange } from "../../../../utils/apis/master/Master";
import { bestSellingProduct } from "../../../../utils/apis/Home/Homeapi";

const HeaderOffcanvas = (props) => {
  const handleLinkClick = () => {
    props.handleClose();
  };
  console.log(props.data, "props?.data props.data");

  const [priceData, setpriceData] = useState({});
  const getAllPrice = async () => {
    const res = await priceRange();
    if (res?.success) {
      setpriceData(res?.data);
    } else {
      console.error("Error fetching data:", res?.error);
    }
  };

  useEffect(() => {
    getAllPrice();
  }, []);

  const minPrice = parseFloat(priceData.minPrice);
  const maxPrice = parseFloat(priceData.maxPrice);

  // Calculate the interval for each range segment
  const interval = (maxPrice - minPrice) / 8;
  const priceRanges = [];

  // Generate 8 price ranges
  for (let i = 0; i < 8; i++) {
    const rangeMin = Math.round(minPrice + interval * i);
    const rangeMax = Math.round(minPrice + interval * (i + 1));
    priceRanges.push({ min: rangeMin, max: rangeMax });
  }

  const [occasionprod, setOcassionprod] = useState([]);

  const getOcassion = async () => {
    const res = await Occasion();
    if (res?.success) {
      setOcassionprod(res?.data)
    }
  }

  const [bestSellingprod, setBestSellingprod] = useState([]);

  const getBestSellingProduct = async () => {
    const res = await bestSellingProduct();
    if (res?.success) {
      setBestSellingprod(res?.data)
    }
  }

  useEffect(() => {
    getOcassion();
    getBestSellingProduct();
  }, []);
  return (
    <>
      <Offcanvas
        className="mobheadoffcanvas"
        show={props.show}
        onHide={props.handleClose}
        {...props}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <Link to="/home" onClick={handleLinkClick}>
              <img
                className="mobloggoo"
                src={
                  process.env.PUBLIC_URL + "/assest/image/logo/header-logo.png"
                }
              />{" "}
            </Link>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <section>
            <div className="Headeraccord">
              <Accordion>
                {props?.data?.slice(0, 5).map((val, index) => (
                  <Accordion.Item eventKey={index}>
                    <Accordion.Header>{val?.name}</Accordion.Header>
                    <Accordion.Body>
                      <div className="secondMobiledrop mb-0">
                        <div className="subaccmenu">
                          <Link
                            to={"/shop-promotional"}
                            onClick={handleLinkClick}
                          ></Link>
                        </div>
                        {val?.sub_categories?.map((val1) => (
                          <div className="subaccmenu">
                            <Link
                             to={`/emp-satifaction?SubcategoryId=${val1?.id}`}
                              onClick={handleLinkClick}
                            >
                              {val1?.name}
                            </Link>
                          </div>
                        ))}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}

                <Accordion.Item eventKey="5">
                  <Accordion.Header>Shop Products</Accordion.Header>
                  <Accordion.Body>
                    <Accordion>
                      {props.data?.map((val, index) => (
                        <Accordion.Item eventKey={`5${index}`}>
                          <Accordion.Header>{val?.name}</Accordion.Header>
                          <Accordion.Body>
                            <div className="secondMobiledrop mb-0">
                              {val?.sub_categories?.map((val1) => (
                                <div className="subaccmenu">
                                  <Link
                                    to={`/emp-satifaction?SubcategoryId=${val1?.id}`}
                                    onClick={handleLinkClick}
                                  >
                                    {val1?.name}
                                  </Link>
                                </div>
                              ))}

                              {/* <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div> */}
                            </div>
                          </Accordion.Body>
                        </Accordion.Item>
                      ))}

                      {/* <Accordion.Item eventKey="52">
                        <Accordion.Header> Awards</Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Awards
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="53">
                        <Accordion.Header> Accessories</Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Awards
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="54">
                        <Accordion.Header>
                          {" "}
                          Gift Hampers & Sets
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Awards
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="55">
                        <Accordion.Header> Apparel</Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Awards
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="55">
                        <Accordion.Header> Lapel pins</Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Awards
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="56">
                        <Accordion.Header> Trophies</Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Awards
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div>
                          </div>
                        </Accordion.Body>
                      </Accordion.Item> */}
                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="6">
                  <Accordion.Header>Shop by</Accordion.Header>
                  <Accordion.Body>
                    <Accordion>
                      <Accordion.Item eventKey="61">
                        <Accordion.Header>Interest</Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                            {props?.data?.map((val) => (
                              <div className="subaccmenu">
                                <Link
                                  to={`all-category/${val?.id}`}
                                  onClick={handleLinkClick}
                                >
                                  {val?.name}
                                </Link>
                              </div>
                            ))}

                            {/* <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div> */}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="63">
                        <Accordion.Header> Price</Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                            {priceRanges.map((range, index) => (
                              <div className="subaccmenu">
                                <Link
                                  to={`/product?minprice=${range.min}&maxprice=${range.max}`}
                                  onClick={handleLinkClick}
                                >
                                  ₹{range.min} - ₹{range.max}
                                </Link>
                              </div>
                            ))}

                            {/* <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div> */}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="64">
                        <Accordion.Header> Occasions</Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                          {occasionprod?.map((val) =>
                            <div className="subaccmenu">
                              <Link
                               to={`product/${val?.id}`}
                                onClick={handleLinkClick}
                              >
                                {val?.name}
                              </Link>
                            </div>)}

                            {/* <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Accessories
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to={"/emp-satifaction"}
                                onClick={handleLinkClick}
                              >
                                Gift Hampers & Sets
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Apparel
                              </Link>
                            </div>

                            <div className="subaccmenu">
                              <Link
                                to="/emp-satifaction"
                                onClick={handleLinkClick}
                              >
                                Lapel pins
                              </Link>
                            </div> */}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="65">
                        <Accordion.Header>
                          {" "}
                          Best Selling Product
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="secondMobiledrop mb-0">
                          {bestSellingprod?.map((val) =>
                            <div className="subaccmenu">
                              <Link
                               to={`productDetails/${val?.id}?type=Best Selling`}
                                onClick={handleLinkClick}
                              >
                                {val?.name}
                              </Link>
                            </div>)}

                          
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>

                <div className="Customise-gift-link">
                  <Link to="/customizable-product" onClick={handleLinkClick}>
                    Customise
                    <FontAwesomeIcon
                      className="Customise-gift-icon"
                      icon={faGift}
                    />
                  </Link>
                </div>
                <div className="Customise-gift-link">
                  <Link to="/offers" onClick={handleLinkClick}>
                    Offers
                  </Link>
                </div>
              </Accordion>
            </div>
          </section>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default HeaderOffcanvas;
